
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DashboardErrorStateProps {
  message: string;
  onRetry: () => void;
}

const DashboardErrorState: React.FC<DashboardErrorStateProps> = ({ 
  message, 
  onRetry 
}) => {
  return (
    <div className="max-w-6xl mx-auto pt-8 text-center">
      <div className="glass-panel rounded-xl p-6 flex flex-col items-center">
        <AlertTriangle className="h-12 w-12 text-yellow-500 mb-4" />
        <h2 className="text-xl font-semibold mb-2">Something went wrong</h2>
        <p className="text-muted-foreground mb-4">{message}</p>
        <Button onClick={onRetry}>Try again</Button>
      </div>
    </div>
  );
};

export default DashboardErrorState;
